import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeftIcon, ArrowRightIcon, QuoteIcon } from "lucide-react";
import { TESTIMONIALS } from "../../data/testimonials";
import { PlaceholderTag } from "../ui/PlaceholderTag";
import { Reveal } from "../ui/Reveal";
export function TestimonialsSlider() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(1);
  const t = TESTIMONIALS[index];
  const go = (d: number) => {
    setDir(d);
    setIndex(i => (i + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  };
  return <section className="shell section border-t border-line" aria-roledescription="carousel" aria-label="Client testimonials" data-id="element-195" data-mp="1lhajy0a2zh8q">
      <Reveal className="grid gap-10 lg:grid-cols-[0.6fr_1.4fr]" data-id="element-196" data-mp="1q8skin86zft6">
        <div data-id="element-197" data-mp="tpuqpne0qw9j">
          <p className="t-eyebrow mb-5 flex items-center gap-3 text-accent-soft" data-id="element-198" data-mp="tqe892zrbin1"><span className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-199" data-mp="to1oqlecp07v" />Testimonials</p>
          <h2 className="t-h2 max-w-[12ch]" data-id="element-200" data-mp="xpmw5r848mao">What clients say.</h2>
          <div className="mt-6" data-id="element-201" data-mp="36y0eug1k5ds2"><PlaceholderTag data-id="element-202" data-mp="36yiku4e0v6d6">Placeholder reviews — real ones coming soon</PlaceholderTag></div>
          <div className="mt-10 flex items-center gap-3" data-id="element-203" data-mp="320h0lg4v1104">
            <button type="button" onClick={() => go(-1)} aria-label="Previous testimonial" className="grid h-12 w-12 place-items-center rounded-full border border-line-strong transition-colors duration-150 ease-out hover:bg-white/5" data-id="element-204" data-mp="2x8p7oyy8ej6t">
              <ArrowLeftIcon className="h-5 w-5" data-id="element-205" data-mp="2nbu9kh5vekt2" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Next testimonial" className="grid h-12 w-12 place-items-center rounded-full border border-line-strong transition-colors duration-150 ease-out hover:bg-white/5" data-id="element-206" data-mp="2j8xvn3r9zcvg">
              <ArrowRightIcon className="h-5 w-5" data-id="element-207" data-mp="29cl3497gv52a" />
            </button>
            <span className="ml-3 font-mono text-sm text-muted" aria-live="polite" data-id="element-208" data-mp="cj9ksf24vemg">
              {index + 1} / {TESTIMONIALS.length}
            </span>
          </div>
        </div>
        <div className="relative min-h-[280px] overflow-hidden" data-id="element-209" data-mp="220evbxznw1jv">
          <QuoteIcon className="h-10 w-10 text-accent" aria-hidden data-id="element-210" data-mp="21y25kynnwmw9" />
          <AnimatePresence mode="wait" custom={dir} data-id="element-211" data-mp="26rn730ogrz07">
            <motion.figure key={index} custom={dir} initial={{
            opacity: 0,
            x: dir * 24
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: dir * -24
          }} transition={{
            duration: 0.24,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-6" data-id="element-212" data-mp="1s1z6y2s0r6e2">
              <blockquote className="font-display text-[clamp(1.5rem,1rem+2vw,3.5rem)] font-medium leading-[1.2] tracking-tight text-fg" data-id="element-213" data-mp="2poemv04srvzi">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 text-muted" data-id="element-214" data-mp="2fqif8ib2jj65">
                <span className="block text-fg" data-id="element-215" data-mp="zd9zlm0de4tv">{t.name}</span>
                {t.role}
              </figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>
      </Reveal>
    </section>;
}